/**
 * Byte helpers. Isomorphic: only TextEncoder/TextDecoder and globalThis.crypto.
 */
const encoder = new TextEncoder();
const decoder = new TextDecoder('utf-8', { fatal: true });
export function utf8(text) {
    return copy(encoder.encode(text));
}
export function fromUtf8(bytes) {
    return decoder.decode(bytes);
}
/** Copy into a fresh ArrayBuffer-backed array (also narrows ArrayBufferLike → ArrayBuffer). */
export function copy(bytes) {
    const out = new Uint8Array(bytes.length);
    out.set(bytes);
    return out;
}
export function concat(...parts) {
    let length = 0;
    for (const p of parts)
        length += p.length;
    const out = new Uint8Array(length);
    let offset = 0;
    for (const p of parts) {
        out.set(p, offset);
        offset += p.length;
    }
    return out;
}
/** Length-leaking but otherwise constant-time comparison. */
export function bytesEqual(a, b) {
    if (a.length !== b.length)
        return false;
    let diff = 0;
    for (let i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
export function randomBytes(length) {
    const out = new Uint8Array(length);
    globalThis.crypto.getRandomValues(out);
    return out;
}
const B64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const B64URL_LOOKUP = new Int16Array(128).fill(-1);
for (let i = 0; i < B64URL.length; i++)
    B64URL_LOOKUP[B64URL.charCodeAt(i)] = i;
/** RFC 4648 §5 base64url without padding. */
export function toBase64Url(bytes) {
    let out = '';
    let i = 0;
    for (; i + 2 < bytes.length; i += 3) {
        const n = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        out +=
            B64URL.charAt((n >> 18) & 63) +
                B64URL.charAt((n >> 12) & 63) +
                B64URL.charAt((n >> 6) & 63) +
                B64URL.charAt(n & 63);
    }
    const rest = bytes.length - i;
    if (rest === 1) {
        const n = bytes[i] << 16;
        out += B64URL.charAt((n >> 18) & 63) + B64URL.charAt((n >> 12) & 63);
    }
    else if (rest === 2) {
        const n = (bytes[i] << 16) | (bytes[i + 1] << 8);
        out +=
            B64URL.charAt((n >> 18) & 63) + B64URL.charAt((n >> 12) & 63) + B64URL.charAt((n >> 6) & 63);
    }
    return out;
}
/**
 * Strict base64url decoder: rejects padding, non-alphabet characters, impossible lengths
 * and non-canonical trailing bits (so every byte string has exactly one encoding).
 */
export function fromBase64Url(text) {
    if (text.length % 4 === 1)
        throw new Error('base64url: invalid length');
    const out = new Uint8Array(Math.floor((text.length * 3) / 4));
    let buffer = 0;
    let bits = 0;
    let o = 0;
    for (let i = 0; i < text.length; i++) {
        const c = text.charCodeAt(i);
        const v = c < 128 ? B64URL_LOOKUP[c] : -1;
        if (v < 0)
            throw new Error('base64url: invalid character');
        buffer = (buffer << 6) | v;
        bits += 6;
        if (bits >= 8) {
            bits -= 8;
            out[o++] = (buffer >> bits) & 0xff;
        }
    }
    if (bits > 0 && (buffer & ((1 << bits) - 1)) !== 0) {
        throw new Error('base64url: non-canonical trailing bits');
    }
    return out;
}
export function toHex(bytes) {
    let out = '';
    for (const b of bytes)
        out += b.toString(16).padStart(2, '0');
    return out;
}
export function fromHex(hex) {
    if (hex.length % 2 !== 0 || !/^[0-9a-fA-F]*$/.test(hex))
        throw new Error('hex: invalid input');
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i++)
        out[i] = Number.parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    return out;
}
//# sourceMappingURL=bytes.js.map